import {Box, Grid, Typography} from '@mui/material';
import React from 'react';
import {SectionHeader} from './header-section';

const attestationText =
    'Disclaimer: If using insurance, your carrier is responsible for determining coverage and your applicable financial responsibility for your care. '
    +
    'This estimate is for informational purposes only and does not guarantee coverage or payment. Final costs may vary based on services provided and how any applicable insurance coverage is applied to your account. '
    +
    'For applicable insurance coverage details, please contact your insurance carrier.';



export const AttestationSection = () => {
  return (
      <Box mb={2}>
        <SectionHeader title="Attestation" testId="attestation-title"/>
        <Grid container spacing={4} sx={{mb: 3}}>
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="flex-end" gap={2}>
              <Typography variant="body2" sx={{whiteSpace: 'nowrap'}}>
                Signature
              </Typography>
              <Box sx={{
                flexGrow: 1,
                borderBottom: '1px solid #d0d0d0',
                mb: 0.5,
              }}/>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="flex-end" gap={2}>
              <Typography variant="body2" sx={{whiteSpace: 'nowrap'}}>
                Date Signed
              </Typography>
              <Box sx={{
                flexGrow: 1,
                borderBottom: '1px solid #d0d0d0',
                mb: 0.5,
              }}/>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="flex-end" gap={2}>
              <Typography variant="body2" sx={{whiteSpace: 'nowrap'}}>
                Witness
              </Typography>
              <Box sx={{
                flexGrow: 1,
                borderBottom: '1px solid #d0d0d0',
                mb: 0.5,
              }}/>
            </Box>
          </Grid>
        </Grid>
        <Typography variant="caption" color="text.secondary" component="div">
          {attestationText}
        </Typography>
      </Box>
  );
}